import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cee243c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "events" }
const _hoisted_2 = { class: "pagination" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("< Previous")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Next >")
const _hoisted_5 = { id: "pageSelectDiv" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "pageSizeSelect",
  style: {"flex":"1","text-align":"right","margin-right":"10px"}
}, "Page Size: ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "2", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "5" }, "5", -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventCard = _resolveComponent("EventCard")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, "Events for " + _toDisplayString(_ctx.userState.userInfo.name), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventState.events, (event) => {
      return (_openBlock(), _createBlock(_component_EventCard, {
        key: event.id,
        event: event
      }, null, 8, ["event"]))
    }), 128)),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.page != 1)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            id: "page-prev-link",
            to: { name: 'EventList', query: { page: _ctx.page - 1, limit: _ctx.pageSize } },
            rel: "prev"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      (_ctx.hasNextPage)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            id: "page-next-link",
            to: { name: 'EventList', query: { page: _ctx.page + 1, limit: _ctx.pageSize } },
            rel: "next"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _withDirectives(_createElementVNode("select", {
        name: "pageSizeSelect",
        id: "pageSizeSelect",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pageSize) = $event)),
        onChange: _cache[1] || (_cache[1] = ($event: any) => (
          _ctx.$router.push({
            name: 'EventList',
            query: { page: _ctx.page, limit: _ctx.pageSize },
          })
        ))
      }, _hoisted_9, 544), [
        [_vModelSelect, _ctx.pageSize]
      ])
    ])
  ]))
}